import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';

import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  DOCUMENT,
  inject,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { SessionService } from '@services/session.service';
import { filter, take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, RouterOutlet],
})
export class AppComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  private session = inject(SessionService);
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);

  isMobile$ = this.session.isMobile$;
  game$ = this.session.game$;
  theme$ = this.session.theme$;

  ngOnInit(): void {
    this.updateBodyClass();
    this.checkRouting();
  }

  private checkRouting(): void {
    this.breakpointObserver
      .observe(['(max-width: 767px)'])
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        const extras = this.session.thirdPartyToken
          ? {
              queryParams: {
                token: this.session.thirdPartyToken,
                gameUuid: this.session.gameUuid,
                instance: this.session.instance,
              },
            }
          : undefined;
        const urlToNavigate = window.location.pathname;

        if (result.matches) {
          this.session.setIsMobile(true);
          if (!urlToNavigate.startsWith('/m')) {
            this.router.navigate(['/m'], extras);
          }
        } else {
          this.session.setIsMobile(false);
          if (!urlToNavigate.startsWith('/d')) {
            this.router.navigate(['/d'], extras);
          }
        }
      });
  }

  private updateBodyClass(): void {
    const bodyClass = 'mobile-version';
    this.isMobile$.pipe(untilDestroyed(this)).subscribe((isMobile) => {
      if (isMobile) {
        this.document.body.classList.add(bodyClass);
      } else {
        this.document.body.classList.remove(bodyClass);
      }
    });
    this.theme$
      .pipe(
        filter((theme) => !!theme),
        take(1),
      )
      .subscribe((theme) => {
        if (theme!.desktopFullResolutionFormat) {
          this.document.body.classList.add('full-format');
        }
      });
  }
}
